import dayjs from "dayjs";
import * as Yup from "yup";

const validationSchema = Yup.object({
  mobileNo: Yup.string()
    .matches(
      /^[0-9]{10}$/,
      "Invalid mobile number. Please enter a 10-digit number"
    )
    .required("Mobile number is required"),
});

const validationSchemaSupport = Yup.object({
  name: Yup.string()
    .matches(
      /^[A-Za-z .]+$/,
      "Please enter a valid name using alphabetic characters, spaces, and periods only."
    )
    .required("Name is required")
    .min(2, "First name minimum 2 characters")
    .max(40, "First and last name combined should not exceed 40 characters"),
  email: Yup.string()
    .email("Invalid email ID")
    .required("Email ID is required"),
  query: Yup.string().required("Query is required"),
  phoneNumber: Yup.string()
    .matches(
      /^[0-9]{10}$/,
      "Invalid phone number. Please enter a 10-digit number"
    )
    .required("Phone number is required"),
  // captchaResponse: Yup.string().required("Recaptcha is required!"),
});

export { validationSchema, validationSchemaSupport };
